<template>
  <div class="header_box" >
    <nav class="navbar navbar-default">
      <div class="container-fluid container">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" aria-expanded="false" data-target="#bs-example-navbar-collapse-1">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link to="/" class="navbar-brand"><img src="@/assets/images/newlogo.png" alt=""></router-link>
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav">
            <li ><a href="/#manager" @click="isActive(0)">Board Member</a></li>
            <li ><a href="/#committee" @click="isActive(1)">Advisory Committee</a></li>
            <li ><a href="/#curriculum" @click="isActive(2)">Courses</a></li>
            <!-- <li><router-link to="/kcts">Our Program</router-link></li> -->
            <li @click="isActive(3)"><router-link to="/video/5285890809975080336">Videos</router-link></li>
          </ul>
          <ul class="nav navbar-nav navbar-right">
            <li><a href="https://www.gasauniversity.com/"><div>中文</div></a></li>
            <li class="awithborder"><a target="_blank" href="https://jinshuju.net/f/taKln8"><div >Apply Now</div></a></li>
          </ul>
        </div><!-- /.navbar-collapse -->
      </div><!-- /.container-fluid -->
    </nav>
  </div>
</template>
<style lang="less" scoped>
.header_box{
  position:fixed;
  top:0;
  left:0;
  width:100%;
  z-index: 1001;
  background-color: transparent;
}
.showNone {
  color: #fff;
  text-decoration: none;
}
.container{
  width: 80%;
  max-width: 1200px;
}
.navbar-default{
  background-color: rgba(0,0,0,0.8);
  // background: -webkit-linear-gradient(#000, transparent);
  // background: -o-linear-gradient(#000, transparent);
  // background: -moz-linear-gradient(#000, transparent);
  // background: linear-gradient(#000, transparent);
  height:70px;
  margin-bottom:0;
  border:none;
  // border-bottom:1px solid #fff;
  .navbar-brand{
    height:70px;
    padding:18px 0 18px 10px;
    img{
      height: 100%;
    }
  }
  .navbar-nav{
    margin-left:40px;
    li>a{
    color:#fff;
    }
    li>a:hover{
      border-color:#fff;
    }
    .active{
      border-color:#fff;
    }
    .awithborder{
      a{
        padding-left:0;
        padding-right:10px;
        padding-top: 23px;
        padding-bottom: 21px;
        div{
          border:1px solid #fff;
          border-radius:5px;
          background: #fff;
          color:#000;
          padding:2px 10px;
        }
      }
    }
  }
  .navbar-right{
    li>a:hover{
      border-color:transparent;
    }
  }
}
.navbar-default .navbar-nav>.open>a{
  background-color: rgba(0,0,0,0.3);
  color:#fff;
}
.navbar-nav>li>.dropdown-menu{
  background-color: rgba(0,0,0,0.6);
  border-radius: 0;
  margin:0;
  color:#fff;
}
.dropdown-menu>li>a:hover{
  color: #000;
  background-color: #fff;
}
@media (min-width: 768px){
  .navbar{
    border-radius: 0;
    .navbar-nav>li>a{
      padding-top:25px;
      padding-bottom:23px;
      border-bottom:2px solid transparent;
    }
  }
  .navbar>.container .navbar-brand, .navbar>.container-fluid .navbar-brand{
    margin-left:0;
  }
}
@media screen and (min-width: 768px) and (max-width: 996px){
  .navbar-default{
    .navbar-nav{
      li{
        a{
          padding-left:5px;
          padding-right:10px;
        }
      }
    }
    .navbar-right{
      margin-left:0;
    }
  }
}
</style>
<script>
export default {
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    isActive: function (j) {
      let odiv = document.getElementById('bs-example-navbar-collapse-1')
      let aarr = odiv.getElementsByTagName('a')
      for (let i = 0; i < aarr.length; i++) {
        aarr[i].className = ''
      }
      aarr[j].className = 'active'
    },
    navTo: function () {
      let navto = $(this).attr('navto')
      if (navto !== '#') {
        let $div = $('#' + navto)
        let top = $div.offset().top || 0
        $('html,body').animate({'scroll-top': top - 70}, 500)
      } else {
        $('html,body').animate({'scroll-top': 0}, 500)
      }
    },
    addClass: function () {
      let odropdown = document.getElementsByClassName('dropdown')[0]
      odropdown.className = 'dropdown open'
    },
    removeClass: function () {
      let odropdown = document.getElementsByClassName('dropdown')[0]
      odropdown.className = 'dropdown'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/header.vue